import {  useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import axiosInstance from '../utils/axios';


const ChangePasswordModal = ({ open, setOpen }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  };

    const handleFinish = async (values) => {
        setLoading(true);

        try {
            await axiosInstance.post(`accounts/change-password/`, values);
            message.success("Language added successfully!");
            form.resetFields();
            setOpen(false);
        } catch (error) {
            const emsg = error.response?.data?.message;
            message.error(emsg || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

	return (
		<Modal
			title="Change Current password"
            open={open}
            onCancel={handleCancel}
            destroyOnHidden
            okButtonProps={{
                autoFocus: true,
                htmlType: 'submit',
                loading: loading,
                disabled: loading,
            }}
            onOk={() => form.submit()}
		>
 			<Form
                layout="vertical"
                form={form}
                name="pwd_form"
                onFinish={handleFinish}
            >
                <Form.Item
                    label="Old Password"
                    name="old_password"
                    rules={[{ required: true, message: 'Please enter current password' }]}
                >
                    <Input type="password"/>
                </Form.Item>

                <Form.Item
                    label="New Password"
                    name="new_password"
                    rules={[
                        { required: true, message: 'Please enter new password' }, 
                        { min: 8, message: 'Password must be at least 8 characters long' }
                    ]}
                >
                    <Input type="password" />
                </Form.Item>
            </Form>
		</Modal>
	)
}

export default ChangePasswordModal